import React from 'react';

import { c } from 'ttag';

// Reveal mask is per word, not per line: a translated string has no fixed line count.
// The split happens at render on the translated string; the words are not msgids.
const LoginClaim = () => {
    const claim = c('Login claim').t`Steering your contracts on your own`;

    return (
        <div className="login-claim">
            <p className="login-claim__lead">
                {c('Login claim')
                    .t`Follow the activity as it happens, without waiting for the next steering committee.`}
            </p>
            <p className="login-claim__title">
                {claim.split(' ').map((mot, index, mots) => (
                    <React.Fragment key={index}>
                        <span className="login-claim__mask">
                            <i style={{ animationDelay: `${0.4 + index * 0.08}s` }}>{mot}</i>
                        </span>
                        {index < mots.length - 1 && ' '}
                    </React.Fragment>
                ))}
            </p>
        </div>
    );
};

export default LoginClaim;
